import type { ComponentType } from 'react'

import { useFederatedComponent } from 'modules/app-registry/hooks/useFederatedComponent'

import { WidgetComponent } from '../../types/widgets.types'
import { WidgetWrapper } from '../WidgetWrapper'

export const CSMPerformanceOverviewWidget: WidgetComponent = widgetProps => {
  const { module, isLoaded, isError, missingRemoteUrl } = useFederatedComponent(
    process.env.REACT_APP_AFTER_SALES_APP_DEV_PATH,
    'after_sales',
    './CRMComponents',
    'afterSalesApp'
  )

  const ExposedCSMPerformance = (
    (isLoaded && !isError && !missingRemoteUrl ? module : null) as
      | (typeof module & {
          ExposedCSMPerformance: ComponentType
        })
      | null
  )?.ExposedCSMPerformance

  return (
    <WidgetWrapper {...widgetProps} isLoading={!isLoaded}>
      {ExposedCSMPerformance && <ExposedCSMPerformance />}
    </WidgetWrapper>
  )
}
